import { passwordStrength } from 'check-password-strength';

const checkPasswordStrength = (diversity = 3, length = 10) => (password = '') => {
  const result = passwordStrength(password);
  return result.contains.length >= diversity && result.length >= length;
};

export { checkPasswordStrength };
